import {
  FeedbackCardContainer,
  LoadingPage
} from '@yes.technology/react-toolkit'
import { useSelector } from 'react-redux'

import 'bootstrap/dist/css/bootstrap.min.css'

import AuthenticationRenewal from 'authentication/shared/components/AuthenticationRenewal'
import EnvironmentAlert from 'infrastructure/Application/components/EnvironmentAlert'

import { useHandleLanguage, useToken } from 'shared/hooks'

import { Font } from '@react-pdf/renderer'
import CancelModal from 'site/Renderer/components/EditValues/CancelModal/CancelModal'
import { Outlet } from 'react-router-dom'
import { BlockerContext } from 'site/shared/hooks/useBlocker'
import { useBlockerProvider } from 'site/shared/hooks/useBlockerProvider'
import 'shared/assets/css/default.css'
import 'shared/assets/css/fonts.css'
import ScrollToDynamicHashElement from 'shared/utils/router/ScrollToDynamicHashElement'
import { SiteStateContext, useSiteStateProvider } from 'siteState/shared'
import { useFeatureFlag } from 'featureFlags/useFeatureFlag'
import apiAsync from 'infrastructure/shared/api/api-async'
import { useEffect } from 'react'

export type ApiSystemType = { api: { isPending: boolean } }

Font.register({
  family: 'Barlow',
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/barlow/v12/7cHpv4kjgoGqM7EPC8E46HsxnA.ttf'
    },
    {
      src: 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3_-gc4FAtlT47dw.ttf',
      fontWeight: 500
    },
    {
      src: 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E30-8c4FAtlT47dw.ttf',
      fontWeight: 600
    },
    {
      src: 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3t-4c4FAtlT47dw.ttf',
      fontWeight: 700
    }
  ]
})

const ApplicationContainer: React.FunctionComponent = (): JSX.Element => {
  const isLoading = useSelector((state: ApiSystemType) => state.api?.isPending)

  useToken({ publicSessionToken: window.publicSessionToken })
  useHandleLanguage()

  const [logHttpRequests] = useFeatureFlag('log-http-requests')

  const siteStateProviderValue = useSiteStateProvider()
  const blockerProviderValue = useBlockerProvider()

  useEffect(() => {
    if (logHttpRequests) {
      apiAsync.enableLogging()
    } else {
      apiAsync.disableLogging()
    }
  }, [logHttpRequests])

  return (
    <SiteStateContext.Provider value={siteStateProviderValue}>
      <BlockerContext.Provider value={blockerProviderValue}>
        {isLoading && (
          <div className='loading-page'>
            <LoadingPage />
          </div>
        )}
        <ScrollToDynamicHashElement />
        <EnvironmentAlert environment={window.waEnv} />
        <AuthenticationRenewal />
        <CancelModal />
        <FeedbackCardContainer pauseOnFocusLoss={false} pauseOnHover={false} />
        <Outlet />
      </BlockerContext.Provider>
    </SiteStateContext.Provider>
  )
}

export default ApplicationContainer
